import { Component, OnInit, HostListener } from '@angular/core';
import { ViewportScroller} from '@angular/common';
// import '../../../assets/js/select2.min';
// import * as $ from '../../../assets/js/select2.min';
// import * as $ from "jquery";
import 'jquery';
import '../../../assets/js/material-kit';
import '../../../assets/js/jquery';
import '../../../assets/js/nicepage';
import '../../../assets/js/jQuery3.3.1';
import * as $ from '../../../assets/js/jQuery3.3.1';

import {NavigatorService} from "../../services/navigatorService/navigator.service";
import {UserService} from "../../services/api-handlers/userService/user.service";
import {BootstrapNotifyService} from "../../services/bootstrap-notify/bootstrap-notify.service";
import {CacheService} from "../../services/cacheService/cache.service";
import {ActivatedRoute, Router} from "@angular/router";
import {IResponse} from "../../interfaces/iresponse";
import {SharedFormService} from "../../services/shared-form.service";

@Component({
  selector: 'app-online-admissions',
  templateUrl: './online-admissions.component.html',
  styleUrls: ['./online-admissions.component.css']
})
export class OnlineAdmissionsComponent implements OnInit {
  pageYoffset = 0;
  editState: any;
  public credentials = {
    schools : '',
    StudentName: '',
    DateOfBirth: '',
    PreviousSchool: '',
    PreviousClass: '',
    NewClass: ''
  };
  public schools = [];
  isValidated = false;
  public loading = false;
  public year: number = new Date().getFullYear();
  loaders = {
    loading: false
  };

  @HostListener('window:scroll', ['$event']) onScroll(event){
    this.pageYoffset = window.pageYOffset;
  }
  constructor(private userService: UserService, private cacheService: CacheService,
              private bootstrapService: BootstrapNotifyService, private scroll: ViewportScroller, private navigationService: NavigatorService, private router: Router, private sharedFormService: SharedFormService, private route: ActivatedRoute) { }

  onActivate(event) {
    document.body.scrollTop = 0;
  }

  scrollToContact() {

    if ($('.section-contact-us').length != 0) {
      $("html, body").animate({
        scrollTop: $('.section-contact-us').offset().top
      }, 1000);
    }
  };

  ngOnInit(): void {
    this.getSchools();

    this.route.params.subscribe((params) => {
      this.editState = params['type'];
      if(!!this.editState) {
        const credentials = JSON.parse(localStorage.getItem('LoginCredentials'));
        console.log( "Test",credentials);
        this.credentials = credentials;
      }

    });
    // this.credentials = this.sharedFormService.previewData;
    // this.credentials = JSON.parse(JSON.stringify(this.credentials));
    // console.log('EDITS for Preview', this.credentials);

    /*$(document).ready(function() {
      $('.js-example-responsive').select2({
        width: 'resolve', // need to override the changed default
        theme: 'classic'
      });
    });*/

    /*$(document).ready(function () {
      $('select').selectize({
        sortField: 'text'
      });
    });*/
  }

  scrollToTop(){
    this.scroll.scrollToPosition([0,0]);
  }

  public goToPreviewPage() {
    if (!this.credentials.StudentName || !this.credentials.DateOfBirth || !this.credentials.PreviousSchool || !this.credentials.PreviousClass || !this.credentials.NewClass) {
      return this.bootstrapService.error('Ensure the Dropdown and Other Input Fields are Filled!!');
    } else
    this.loaders.loading = true;
    localStorage.setItem('LoginCredentials', JSON.stringify(this.credentials));
    console.log('',this.credentials );
    this.sharedFormService.admissionData = this.credentials;
    this.navigationService.navigateUrl('/online-admissions/preview');
    this.loaders.loading = false;
    // this.router.navigate(["/online-admissions/preview"]);
  }

  /*public getSchools(): void {
    this.userService.getSchools().subscribe((res: any) => {
      this.schools =  res;
    }, error => {
      this.bootstrapService.error(error.error.message || 'Unable to provide list of Locations');
      // this.bootstrapService.error(error?.error?.description, error?.error?.code);
    });
  }*/
  public getSchools(): void {
    this.userService.getSchools().subscribe((response: IResponse) => {
      this.schools =  response.result;
    }, error => {
      this.bootstrapService.error(error.error.message || 'Unable to provide list of Schools');
      /*this.bootstrapService.error(error.error.description, error.error.code);*/
    });
  }
}
